import { Component, computed, inject, input, output } from '@angular/core';
import { FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CascadeContractSelectInputStore } from './cascade-contract-select-input.store';
import { CascadeSelect } from '@openng/optimus-ui/cascadeselect';
import { TranslatePipe } from '@ngx-translate/core';
import { FieldErrorComponent } from '../../../../modules/shared/components/field-error/field-error.component';

@Component({
    selector: 'app-cascade-contract-select-input',
    templateUrl: './cascade-contract-select-input.component.html',
    providers: [CascadeContractSelectInputStore],
    imports: [
        CascadeSelect,
        ReactiveFormsModule,
        TranslatePipe,
        FieldErrorComponent,
    ],
})
export class CascadeContractSelectInputComponent {

    public readonly store = inject(CascadeContractSelectInputStore);

    public form = input.required<FormGroup>();
    public id = input<string, string | number>('contract', { transform: v => String(v) });

    public contractSelected = output<any>();

    protected required = computed(() => {
        return this.form().get(this.id())?.hasValidator(Validators.required) || false;
    });

    protected isInvalid = computed(() => {
        const control = this.form().get(this.id());
        return control?.invalid && control.touched;
    });
}
